import apiService from "./apiService";

// Get navigate and setErrorMessage functions from custom hook
export const fetchPermissions = async (role, resource, action, loginType, setErrorMessage, navigate) => {
  // Get navigate and setErrorMessage functions from custom hook

  // console.info("Fetching permissions for:", loginType, resource, action);

  // Validate input parameters
  if (!loginType || !resource || !action) {
    console.error("Invalid parameters:", loginType, resource, action);
    if (typeof setErrorMessage === "function") {
      setErrorMessage("Invalid parameters.");
    }
    return false;
  }

  try {
    // Perform API request for the specific resource and action
    const permissionResponse = await apiService.post(
      "permissions",
      { resource, action, loginType },
      setErrorMessage,
      navigate
    );

    // Validate the response structure and check for permissions
    if (permissionResponse && permissionResponse.permissions) {
      if (
        Array.isArray(permissionResponse.permissions) &&
        permissionResponse.permissions.every((permission) =>
          permission.hasOwnProperty("frontendResource") &&
          permission.hasOwnProperty("action") &&
          permission.hasOwnProperty("roles")
        )
      ) {
        // Return true if the permissions array has valid data
        if (permissionResponse.permissions.length > 0) {
          return true;
        } else {
          if (typeof setErrorMessage === "function") {
            setErrorMessage("Invalid permissions structure.");
          }
          console.error("Invalid permissions structure:", permissionResponse);
          return false;
        }
      } else {
        if (typeof setErrorMessage === "function") {
          setErrorMessage("Invalid response.");
        }
        console.error("Invalid response:", permissionResponse);
        return false;
      }
    }
  } catch (error) {
    console.error("Error fetching permissions:", error);
    if (typeof setErrorMessage === "function") {
      setErrorMessage("Error fetching permissions.", error);
    }
    return false;
  }
};
